import React from 'react';
import { PermisionDenied } from '../../../views/pages/manage/common/commonComponents';
import { useGetPermissions } from '../../../layouts/customHook';
import RefundApproval from './RefundApproval';

const RefundApprovalPage = () => {

    const userPermissions = useGetPermissions("studentRefundApproval");
    return (
        userPermissions
            ? <RefundApproval userPermissions={userPermissions} />
            : <PermisionDenied />
    );
}

export default RefundApprovalPage;